import { createGlobalStyle, css } from 'styled-components/macro';
import crossUrl from 'assets/icons/cross.svg';

import 'driver.js/dist/driver.css';

export const TourGlobalStyles = createGlobalStyle`
  ${({ theme }) => css`
    .driver-popover {
      padding: ${theme.spacings.base};
      background-color: ${theme.colors.black};
      color: ${theme.colors.white};
      border-radius: ${theme.radiuses.base};
      max-width: 23.75rem;

      .driver-popover-title {
        ${theme.fonts['heading-4'].css}
      }

      .driver-popover-description {
        margin-top: ${theme.spacings.xs} !important;
        ${theme.fonts['body-14'].css}
      }

      .driver-popover-close-btn {
        top: 16px;
        right: 16px;
        width: 16px;
        height: 16px;
        padding: 0;
        font-size: 0;
        line-height: 0;
        background: none !important;

        mask: url(${crossUrl}) center/contain no-repeat;
        -webkit-mask: url(${crossUrl}) center/contain no-repeat;
        background-color: ${theme.colors.white} !important;

        &:hover {
          opacity: 0.7;
        }
      }

      .driver-popover-arrow {
        border-width: 8px !important;

        &.driver-popover-arrow-side-top {
          border-top-color: ${theme.colors.black};
        }

        &.driver-popover-arrow-side-bottom {
          border-bottom-color: ${theme.colors.black};
        }

        &.driver-popover-arrow-side-left {
          border-left-color: ${theme.colors.black};
        }

        &.driver-popover-arrow-side-right {
          border-right-color: ${theme.colors.black};
        }
      }
    }
  `}
`;
